<div class="wrapper">
  <gains-title title="ABC Policies"></gains-title>
  <div class="screen-container">
    <div class="new-policy-header">
      <h2 class="form-title">ABC Policies</h2>
      <button nz-button nzType="primary" nzShape="round" (click)="onNewPolicyClick()">+ New Policy</button>
    </div>
    <p class="text-color align-left-text">On this page you can create and manage policies.</p>
    <div class="centered-texts">
      <p class="no-items-color margin-bottom-zero form-text">No policies yet.</p>
      <p class="create-item-text form-text">Create policy first.</p>
    </div>
  </div>
</div>
